module.exports = __webpack_public_path__ + "static/media/cft-bg.e920f711.jpg";